import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const { Option } = Select;

const AddWardStaff = () => {
    const [loading, setLoading] = useState(false);
    const [wards, setWards] = useState([]);

    // Fetch wards from API
    useEffect(() => {
        axios
            .get('https://ward3-chandrapur-api.palikaapp.com/api/ward/all')
            .then((response) => {
                setWards(response.data);
            })
            .catch((error) => {
                message.error('Failed to fetch wards.');
                console.error('Error fetching wards:', error);
            });
    }, []);

    const onFinish = (values) => {
        setLoading(true);
        axios
            .post('https://ward3-chandrapur-api.palikaapp.com/api/ward-staff/save', {
                name: values.name,
                phone: values.phone,
                email: values.email,
                ward: values.ward,
            })
            .then(() => {
                message.success('Ward staff saved successfully!');
                setLoading(false);
            })
            .catch((error) => {
                message.error('Failed to save ward staff.');
                console.error('Error:', error);
                setLoading(false);
            });
    };

    return (
        <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
            {/* Sidebar and Header */}
            
                <Header />
            <div className="lg:w-1/5 bg-gray-100 pt-20">
                <Sidebar />
            </div>

            {/* Form Section */}
            <div className="lg:w-4/5 p-6 pt-20 mt-5">
                <h1 className="text-xl lg:text-2xl font-bold mb-6 text-center lg:text-center">
                    वडाको कर्मचारी थप गर्ने फारम
                </h1>
                <div className="flex justify-center">
                    <Form
                        layout="vertical"
                        onFinish={onFinish}
                        className="w-full max-w-md bg-white p-6 shadow-lg rounded-md"
                    >
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: true, message: 'Please input the name!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[{ required: true, message: 'Please input the phone number!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                { required: true, message: 'Please input the email!' },
                                { type: 'email', message: 'Please enter a valid email!' },
                            ]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Designate"
                            name="designate"
                            rules={[{ required: true, message: 'Please input the designate!' }]}
                        >
                            <Input className="border-gray-300 rounded-md" />
                        </Form.Item>

                        <Form.Item
                            label="Ward"
                            name="ward"
                            rules={[{ required: true, message: 'Please select a ward!' }]}
                        >
                            <Select
                                placeholder="Select a ward"
                                className="border-gray-300 rounded-md"
                            >
                                {wards.map((ward) => (
                                    <Option key={ward.id} value={ward.name}>
                                        {ward.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
                            >
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default AddWardStaff;
